import {
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  Switch,
  Flex,
  Typography,
  InputNumber,
} from "antd";
import dayjs from "dayjs";

interface Props {
  employee: any;
  form: any;
  onFinish: (values: any) => void;
}

const { Text } = Typography;

export default function HrmEmployeeEditForm({
  employee,
  form,
  onFinish,
}: Props) {
  return (
    <div className="p-4  rounded-xl shadow-sm border">
      <Flex justify="space-between" align="center" className="mb-4">
        <Text className="text-base font-semibold text-gray-700">
          Chỉnh sửa thông tin nhân viên
        </Text>
      </Flex>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          employeeNo: employee.employeeNo,
          phone: employee.phone,
          addressCurrent: employee.addressCurrent,
          addressPermanent: employee.addressPermanent,
          gender: employee.gender,
          born: employee.born ? dayjs(employee.born) : null,
          isWorking: employee.isWorking,
          isOvertime: employee.isOvertime,
          leaveBalance: employee.leaveBalance,
        }}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Mã nhân viên"
              name="employeeNo"
              rules={[
                { required: true, message: "Vui lòng nhập mã nhân viên" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Số điện thoại"
              name="phone"
              rules={[
                { required: true, message: "Vui lòng nhập số điện thoại" },
                {
                  pattern: /^[0-9]{10,11}$/,
                  message: "Số điện thoại không hợp lệ",
                },
              ]}
            >
              <Input maxLength={11} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Giới tính"
              name="gender"
              rules={[{ required: true, message: "Vui lòng chọn giới tính" }]}
            >
              <Select
                options={[
                  { label: "Nam", value: "MALE" },
                  { label: "Nữ", value: "FEMALE" },
                  { label: "Khác", value: "OTHER" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Ngày sinh"
              name="born"
              rules={[{ required: true, message: "Vui lòng chọn ngày sinh" }]}
            >
              <DatePicker className="w-full" format="DD/MM/YYYY" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label="Số ngày nghỉ" name="leaveBalance">
              <InputNumber max={12} min={0} className="w-full" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={6}>
            <Form.Item
              label="Trạng thái làm việc"
              name="isWorking"
              valuePropName="checked"
            >
              <Switch
                style={{
                  backgroundColor: Form.useWatch("isWorking", form)
                    ? "#d30aee"
                    : "#bfbfbf",
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={6}>
            <Form.Item
              label="Tăng ca"
              name="isOvertime"
              valuePropName="checked"
            >
              <Switch
                style={{
                  backgroundColor: Form.useWatch("isOvertime", form)
                    ? "#d30aee"
                    : "#bfbfbf",
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Địa chỉ hiện tại"
              name="addressCurrent"
              rules={[
                { required: true, message: "Vui lòng nhập địa chỉ hiện tại" },
              ]}
            >
              <Input.TextArea rows={2} />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label="Địa chỉ thường trú"
              name="addressPermanent"
              rules={[
                { required: true, message: "Vui lòng nhập địa chỉ thường trú" },
              ]}
            >
              <Input.TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
